import {U, CITY, __} from "./global";
import {DRAWER} from "./drawer";
import {CARD} from "./card";

export const DELIVERYMAP = {
    map_click: false,
    open_drawer: false,
    default_added: false,
    map: false,
    group: false,
    markers: new Map(),
    icons: new Map(),
    
    search: function() {
        if (!CITY.loading) {
            this.clean_map_points();
            let val = this.search_val();
            if (val.length > 2) {
                CITY.loading = true;

                $.post(
                    '/aj',
                    {
                        term: val,
                        action: 'u',
                        locale: G.locale_id,
                        to: 'lookupcity',
                    },
                    (data) => {
                        CITY.loading = false;
                        this.build_list(data)
                    },
                    'json'
                )
            }
        }
    },

    default_city_list: function() {
        this.clean_map_points();
        CITY.loading = true;
        $.post(
            '/aj',
            {
                action: 'u',
                locale: G.locale_id,
                to: 'defaultcitylist',
            },
            function(data) {
                CITY.loading = false;
                $(".dm__results").html(data.html);
            },
            'json'
        )
    },

    clean_map_points: function() {
        try {
            this.map.removeLayer(this.group);
            this.remove_markers();
        } catch (e){}
    },

    build_list: function(data) {

        $(".dm__results").html('<div class="drawer__citylist drawer__citylist-autocompleter"></div>');

        let autocompleter = $('.drawer__citylist-autocompleter');

        autocompleter.empty();

        if (data.length > 0) {
            data = data.slice(0, 10);
            $.each(data, function (i, item) {
                autocompleter.append('<a href="#" class="drawer__cityitem js-drawer__cityitem-dm" data-id="' + item.id + '" data-title="' + item.title + '">' + item.text + '</a>');
            });
        } else
            autocompleter.append('<a href="#" class="drawer__cityitem">' + __('Не знайдено') + '</a>');
    },

    search_val: function() {
        return $(".dm [name=q]").val();
    },

    tab: function() {
        return $(".dm [name=tab]").val();
    },

    sku: function() {
        return $(".dm [name=sku]").val();
    },

    city_id: function() {
        return $(".dm [name=city_id]").val();
    },

    init: function() {
        this.load_results();
    },

    resize_height: function() {
        if (U.isMobile()) {
            $(".dm__results").css('height', $(".workdrawer .content").outerHeight() - $(".workdrawer .dm__header").outerHeight() - $(".workdrawer .dm__map").outerHeight() - 84);
        } else {
            $(".dm__results").css('height', $(".workdrawer .content").outerHeight() - 184);
            $(".dm__map").css('height', $(".workdrawer .content").outerHeight() - 92);
        }
    },

    load_results: function() {
        this.resize_height();
        if (this.city_id() > 0) {

            $.ajax({
                type: "POST",
                url: "/aj",
                data: {
                    action: 'popup',
                    to: 'dm',
                    tab: this.tab(),
                    sku: this.sku(),
                    city_id: this.city_id(),
                    locale: G.locale_id
                },
                dataType: "json",
                timeout: 5000, // in milliseconds
                success: (data) => {

                    const total_counter = data.our_counter + data.points_counter;

                    if (total_counter==0) {
                        $(".dm__results").html('<div class="alert alert-danger">В цьому місті товар нажаль недоступний</div>');
                        $(".dm__switcher").addClass('hidden');
                    } else {
                        if (data.our_counter > 0 && data.points_counter > 0) {
                            $(".dm__switcher").removeClass('hidden');
                        } else {
                            $(".dm__switcher").addClass('hidden');
                        }

                        if (data.our_counter==0) {
                            $(".dm__switcher").addClass('dm__switcher-hideour');
                            $(".js-dm__switch[data-to=points]").trigger('click');
                        }
                        else
                            $(".dm__switcher").removeClass('dm__switcher-hideour');

                        let counter = this.tab()=='our' && data.our_counter > 0 ? data.our_counter : data.points_counter;

                        if (counter)
                            $(".dm").removeClass('dm-cityless');
                        else
                            $(".dm").addClass('dm-cityless');

                        $(".dm__results").html(this.tab()=='our' ? data.our : data.points);

                        this.show_map(() => {
                            if ($(".dm__results .dm__pointlist").data('lat')) {
                                this.map.setView([$(".dm__results .dm__pointlist").data('lat'),$(".dm__results .dm__pointlist").data('lng')], 12);
                            } else {
                                $(".dm__results .dm__pointlist >.js-dm__point-openmap:eq(0)").trigger('click');
                            }

                        });
                    }
                },
                error: function () {
                    $(".dm__results").html('<div class="alert alert-danger">' + __('Помилка. Спробуйте ще') + '</div>');
                }
            });
        } else {
            // search city
        }
    },

    remove_markers: function() {
        if (this.markers.size > 0)
            this.markers.forEach((item, i) => {
                this.map.removeLayer(item);
                this.markers.delete(i);
            });
    },

    remove_marker: function(key) {
        let exists = this.markers.get(key);

        if (exists)
            this.map.removeLayer(exists);

        this.markers.delete(key);
    },

    add_marker: function(key, value) {
        this.markers.set(key, value);
    },

    default_heights: function() {
        $(".dm").removeClass('dm-full');
        $(".dm__mapcollapse").removeClass('dm__mapcollapse-visible');
        $(".dm__map").css('height', '120');
        $(".dm .dm__pointlist").removeClass('scroll-horizontal-mobile');

        this.map.invalidateSize();
        $(".dm__map").trigger('resize');
    },

    scroll_to_active: function() {
        this.map.invalidateSize();
        $(".dm").addClass('dm-full').css('height', $(".workdrawer .content").outerHeight() - 64);
        $(".dm__map").css('height', $(".workdrawer .content").outerHeight() - 64);
        $(".dm__mapcollapse").addClass('dm__mapcollapse-visible');

        let padding = 0;
        let index = $(".dm__point-active").index();

        for(let i=1; i<=index; i++)
            padding += $(".dm__point:eq(" + (i-1) + ")").outerWidth() + 16;

        $(".dm-full .dm__pointlist").addClass('scroll-horizontal-mobile').animate({scrollLeft: padding}, '200', 'swing');

        this.map_click = false;
    },

    show_point: function(lat, lng, el) {
        this.show_map(() => {
            if (U.isMobile() && ((el.data('type')=='ktc' || el.data('type')=='kyivstar') || DELIVERYMAP.map_click)) {
                this.scroll_to_active();
            }

            this.map.invalidateSize();
            $(".dm__map").trigger('resize');
            this.map.setView([lat, lng], 18);
        });
    },

    show: function(sku) {
        this.open_drawer = true;
        DRAWER.init('workdrawer-deliverymap', {
            action: 'popup',
            to: 'deliverymap',
            locale: G.locale_id,
            sku: sku,
        }, () => {
            this.init();
        });
    },

    productCityChoose: function(sku) {
        this.open_drawer = true;
        DRAWER.init('workdrawer-deliverymap workdrawer-productcitychoose', {
            action: 'popup',
            to: 'deliverymapproductcity',
            locale: G.locale_id,
            sku: sku,
        }, () => {
            this.init();
        });
    },

    hide_map: function() {
        $(".workdrawer-deliverymap").removeClass("workdrawer-deliverymap-big");
        $(".dm__right").remove();
    },

    marker: function(item) {
        let desc = "<b>" + item.find('.dm__pointtitle').html() + "</b><br>" + item.find('.dm__pointaddr').html();
        let marker = L.marker([item.data('lat'), item.data('lng')], {
            icon:  this.icons.get(item.data('type'))
        }).bindPopup(desc);

        marker.id = item.data('id');
        marker.desc = desc;
        marker.type = item.data('type');

        marker.on('click', function(e) {
            this.openPopup();
            try {
                if (typeof this.id !== "undefined" && $(".dm__point[data-id=" + this.id + "]").length > 0) {
                    $(".dm__point-active").removeClass('dm__point-active');
                    $(".dm__point[data-id=" + this.id + "]").addClass('dm__point-active');

                    if (U.isMobile() && (item.data('type')=='ktc' || item.data('type')=='kyivstar'))
                        DELIVERYMAP.scroll_to_active();
                }
            } catch(e) {}

            return false;
        });

        return marker;
    },

    init_pointers: function() {
        this.clean_map_points();

        U.loadscript("https://leaflet.github.io/Leaflet.markercluster/dist/leaflet.markercluster-src.js", () => {

            this.group = L.markerClusterGroup({
                disableClusteringAtZoom: 17
            });

            if ($(".js-dm__point-openmap").length > 0)
                $.each($(".js-dm__point-openmap"), (i, item) =>  {
                    this.group.addLayer(this.marker($(item)));
                });

            this.map.addLayer(this.group);
        });
    },

    show_map: function(callback) {
        if ($(".workdrawer-deliverymap").hasClass("workdrawer-deliverymap-big")) {
            this.init_pointers();
            if (typeof callback === "function")
                callback();
        } else {
            $(".workdrawer-deliverymap").addClass("workdrawer-deliverymap-big");

            if (U.isMobile()) {
                $("<div class=\"dm__map\"><div class=\"dm__mapcontainer\" id=\"dm_map\"></div></div>").insertAfter('.dm__header');
            } else {
                $(".dm").append('<div class="dm__right"><div class="dm__map" id="dm_map"></div></div>');
            }

            $('head').append('<link rel="stylesheet" href="https://unpkg.com/leaflet@1.7.1/dist/leaflet.css" type="text/css" />');
            $('head').append('<link rel="stylesheet" href="/themes/js/leaflet/leaflet.css" type="text/css" />');

            U.loadscript("https://unpkg.com/leaflet@1.7.1/dist/leaflet.js", () => {
                this.map = L.map('dm_map').setView([49.0235629,31.6982193], 6).on('click ', (e) =>  {
                    if (U.isMobile() && !$(".dm").hasClass('dm-full')) {
                        this.map_click = true;
                        $(".dm__pointlist .dm__point:first-child").trigger('click');
                        return false;
                    }
                    else
                        return true;
                });

                const api_key = G.channel==7 ?
                    'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' :
                    'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYW5kcmV5a3RjIiwiYSI6ImNsZm1naGw3cjBiaDEzeHA2Zjg1NTE2ZXQifQ.PbbiE7qSWmAXgIdRwJHkKA';

                // L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                L.tileLayer(api_key, {
                    maxZoom: 18,
                    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                    id: 'mapbox/streets-v11',
                    tileSize: 512,
                    zoomOffset: -1
                }).addTo(this.map);

                this.icons.set('ktc', L.icon({
                    iconUrl: '/themes/img/mapicon-ktc.png',
                    iconSize: [40, 40],
                    popupAnchor: [0, -50],
                    iconAnchor: [20, 50],
                    shadowSize: [0, 0],
                    shadowUrl: false
                }));

                this.icons.set('kyivstar', L.icon({
                    iconUrl: '/themes/img/mapicon-kyivstar.png',
                    iconSize: [40, 40],
                    popupAnchor: [0, -50],
                    iconAnchor: [20, 50],
                    shadowSize: [0, 0],
                    shadowUrl: false
                }));

                this.icons.set('novaposhta', L.icon({
                    iconUrl: '/themes/img/mapicon-novaposhta.png',
                    iconSize: [40, 40],
                    popupAnchor: [0, -50],
                    iconAnchor: [20, 50],
                    shadowSize: [0, 0],
                    shadowUrl: false
                }));

                this.icons.set('novaposhta_postomat', L.icon({
                    iconUrl: '/themes/img/mapicon-novaposhta.png',
                    iconSize: [40, 40],
                    popupAnchor: [0, -50],
                    iconAnchor: [20, 50],
                    shadowSize: [0, 0],
                    shadowUrl: false
                }));

                this.icons.set('ukrpost', L.icon({
                    iconUrl: '/themes/img/mapicon-ukrpost.png',
                    iconSize: [40, 40],
                    popupAnchor: [0, -50],
                    iconAnchor: [20, 50],
                    shadowSize: [0, 0],
                    shadowUrl: false
                }));

                this.init_pointers();

                if (typeof callback === "function")
                    callback();

                this.resize_height();

            });
        }
    },

    update_goods_delivery: function(id) {
        $.post(
            '/aj',
            {
                action: 'goods',
                to: 'delivery',
                locale: G.locale_id,
                id: id,
            },
            function (data) {
                $(".product__sc-delivery").replaceWith(data.html);
            },
            'json'
        );
    },
}

$( document ).ready(function() {

    jQuery("body").on('click', '.js-dm__point-openmap', function(e){
        e.preventDefault();
        e.stopPropagation();
        let btn = $(this);
        $(".dm__point-active").removeClass('dm__point-active');
        btn.addClass('dm__point-active');
        DELIVERYMAP.show_point(btn.data('lat'), btn.data('lng'), btn);

        if (btn.hasClass('dm__point-ktc') || btn.hasClass('dm__point-kyivstar')) {
            $.post(
                '/aj',
                {
                    action: 'u',
                    to: 'savestore',
                    store_id: btn.data('id').split('-')[1],
                    locale: G.locale_id
                },
                (data) => {
                    if (G.product.id) {
                        DELIVERYMAP.update_goods_delivery(G.product.id);

                    }
                },
                'json'
            );
        }

    });

    jQuery("body").on('click', '.js-loop__av', function(e){
        e.preventDefault();
        e.stopPropagation();
        DELIVERYMAP.show($(this).data('sku'));
    });

    jQuery("body").on('click', '.buy-productlimited', function(e){
        e.preventDefault();
        e.stopPropagation();
        let btn = $(this);

        if (!G.city_id) {
            DELIVERYMAP.productCityChoose(btn.data('sku'));
        } else {
            CARD.add(btn.data('sku'), 1, btn.data('list'), btn.data(), 1);
        }
    });

    jQuery("body").on('click', '.js-dm__buy-limited', function(e){
        e.preventDefault();
        e.stopPropagation();
        CARD.addFromMap($(this).data('sku'), $(this).data('city'), $(this).data('warehouse'))
            .then(() => {
                CARD.open().then(() => {
                    CARD.updatePromise();
                })
            })
        ;
    });

    jQuery("body").on('click', '.js-dm__switch', function(e){
        e.preventDefault();
        e.stopPropagation();
        let btn = $(this);
        btn.parent().find('.js-dm__switch').removeClass('dm__switch-active');
        btn.addClass('dm__switch-active');
        btn.parents('.dm').find('[name=tab]').val(btn.data('to'));
        $(".dm").removeClass('dm-our').removeClass('dm-points').addClass('dm-' + btn.data('to'));

        if (!(typeof e.originalEvent === "undefined"))
            DELIVERYMAP.load_results();
    });

    jQuery( "body" ).on( "keyup", ".js-city__select-dm", function(e) {
        DELIVERYMAP.search();
    });

    jQuery("body").on("click", ".js-drawer__cityitem-dm", function (e) {
        e.preventDefault();
        let btn = $(this);
        CITY.set_city(btn.data('id'), btn.data('title'), function() {
            $(".workdrawer-deliverymap .content >.title").html(__('Точки видачі'));
            $(".dm").removeClass('dm-cityless');
            $(".dm [name=city_id]").val(btn.data('id'));
            $(".dm [name=q]").val(btn.data('title'));
            $(".drawer__citysearch-dm").addClass('drawer__citysearch-dm-cityexists');
            DELIVERYMAP.load_results();

            // if ($(".dm input[name=id]").val())
            //     GOODS.update_delivery($(".dm input[name=id]").val());
        });
        return true;
    });

    jQuery("body").on("click", ".dm-full .dm__mapclose, .dm__mapcollapse-visible", function (e) {
        e.preventDefault();
        DELIVERYMAP.default_heights();
    });

    jQuery("body").on("click", ".dm__formclose", function (e) {
        e.preventDefault();
        $(".drawer__citysearch-dm input[name=q]").val('').trigger('reset').trigger('keyup');
        CITY.delete_city(() => {
            $(".dm").addClass('dm-cityless');
            $(".dm__pointlist").remove();
            $(".drawer__citysearch-dm-cityexists").removeClass('drawer__citysearch-dm-cityexists');
            $(".dm [name=q]").focus();
            $(".js-dm__switch[data-to=our]").trigger('click');
            DELIVERYMAP.default_city_list();
        });
    });

});